import { ApexLegend } from 'ng-apexcharts';
import { EventEmitter, Injectable } from '@angular/core';
import { catchError, firstValueFrom, Observable, of, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalViewFileComponent } from '../modals/modal-view-file/modal-view-file.component';
import { environment } from '../../../environments/environment';
import {
  CreateInpur,
  CustomInputConfig,
  DynamicFormResponse,
  Field,
  FieldDinamic,
  Form,
  InputDataSource,
  PageGeneral,
  Section,
  SectionForm,
} from '../models/pages-model/dynamic-page.model';
import { DataPagesGeneral, GeneralFormPage } from '../models/pages-model/page-general.model';
import {
  ActivityFieldParentFields,
  ErrorInpusGeneral,
  GeneralForm,
  InputGeneralAutocomplete,
  InputsGeneralForm,
  OrderByRule,
  TableReader,
} from '../models/pages-model/form-general.model';

@Injectable({
  providedIn: 'root',
})
export class DynamicPageService {
  public emitNewForm = new EventEmitter<{ quotationId: number; idPage: number }>();
  public emitStartCreateForm = new EventEmitter<{ quotationId: number; idPage: number }>();
  public emitInputEdit = new EventEmitter<{
    idForm: number;
    idControl: number;
    idSection: number;
  }>();
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
    private dialog: MatDialog,
  ) {}

  public async getform(quotationId: number, idPage: number): Promise<DynamicFormResponse | null> {
    const response = await firstValueFrom(
      this.http.get<DynamicFormResponse>(this.URL_API + `/dynamic-page/${quotationId}/${idPage}`),
    );
    return response;
  }

  public async transformForm(quotationId: number, idPage: number): Promise<DataPagesGeneral> {
    let Data: DataPagesGeneral = {
      title: '',
      idPage: 1,
      subtitle: '',
      rules: {
        ruleInputForm: {},
        rulesSection: {},
      },
      section: [],
    };
    const ress: DynamicFormResponse | null = await this.getform(quotationId, idPage);

    Data.title = ress?.title ?? '';
    Data.idPage = ress?.idPage ?? 1;
    Data.subtitle = ress?.subtitle ?? '';
    Data.rules = ress?.rules
      ? this.generalService.stringToJson(ress.rules)
      : { ruleInputForm: {}, rulesSection: {} };
    ress?.sections?.forEach((sectionAux) => {
      let forms: GeneralFormPage[] = [];
      sectionAux.forms.forEach((form: Form) => {
        const formAux: OrderByRule = form.rulE_BY_ORDER
          ? this.generalService.stringToJson(form.rulE_BY_ORDER)
          : { orderDefault: {}, orderRule: {} };

        let multifrom: {
          fields: InputsGeneralForm[];
          repeatIndex: number;
        }[] = [];
        form.repeatGroups.forEach((repeatGroups) => {
          const fields: InputsGeneralForm[] = [];

          // if de pruebas borrar
          if (form.idForm == 30) {
            const newData: TableReader = {
              roleType: '0',
              label: 'reader-Table',
              fieldName: 'reader-Table',
              url: '/getHistorial/',
              idControl: 999,
              idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${200}`,
              disabled: false,
              error: {},
              rules: [],
              quotationId: quotationId,
              view: true,
              typeInput: 'reader-Table',
              colFull: true,
              order: 0,
            };
            fields.push(newData);
          }

          repeatGroups.fields.forEach((fieldsAux: Field) => {
            const inputDataSourceAux: InputDataSource | null = fieldsAux.selectProperties
              ? this.generalService.stringToJson(fieldsAux.selectProperties.inputDataSource)
              : null;

            // Normaliza inputSelect para usar { value, description } si vienen como { data, name }
            if (inputDataSourceAux && (inputDataSourceAux as any).inputSelect) {
              const rawInputSelect = (inputDataSourceAux as any).inputSelect as any;
              (inputDataSourceAux as any).inputSelect = {
                value: rawInputSelect?.value ?? rawInputSelect?.data ?? '',
                description: rawInputSelect?.description ?? rawInputSelect?.name ?? '',
              };
            }

            const rulesAux: { rules: ActivityFieldParentFields[] } | null =
              this.generalService.stringToJson(fieldsAux.rules);
            rulesAux
              ? rulesAux.rules.forEach((rule) => {
                  const parts = rule.parentFieldId.split('-');
                  if (parts.length >= 5) {
                    parts[parts.length - 2] = String(repeatGroups.repeatIndex);
                    rule.parentFieldId = parts.join('-');
                  }
                })
              : null;

            const errorAux: ErrorInpusGeneral | null = this.generalService.stringToJson(
              fieldsAux.errorConfig,
            );

            if (fieldsAux.inputType === 'input-general') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                functionEvent: this.generalService.stringToJson(fieldsAux.functionName),
              });
            }

            if (fieldsAux.inputType === 'input-general-text-area') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value:
                  inputDataSourceAux && inputDataSourceAux.text && inputDataSourceAux.text != ''
                    ? inputDataSourceAux.text
                    : fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
              });
            }

            if (fieldsAux.inputType === 'input-general-checkbox') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ?? {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
              });
            }

            if (fieldsAux.inputType === 'input-general-currency') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                mask: 'separator',
                prefix: '$',
                typeData: '',
                suffix: '',
                thousandSeparator: ',',
                allowNegativeNumbers: true,
                functionEvent: this.generalService.stringToJson(fieldsAux.functionName),
              });
            }

            if (fieldsAux.inputType === 'input-general-number') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                mask: 'separator',
                prefix: '',
                typeData: '',
                suffix: '',
                thousandSeparator: ',',
                allowNegativeNumbers: true,
              });
            }

            if (fieldsAux.inputType === 'input-general-phone') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                mask: '(000) 000-0000',
                prefix: '',
                typeData: '',
                suffix: '',
                thousandSeparator: '',
                allowNegativeNumbers: false,
              });
            }

            if (fieldsAux.inputType === 'input-general-percentage') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                mask: '000',
                prefix: '',
                typeData: '',
                suffix: '%',
                thousandSeparator: '',
                allowNegativeNumbers: false,
              });
            }

            if (fieldsAux.inputType === 'input-general-calendar') {
              const date = this.generalService.parseDate(fieldsAux.value);
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: date ?? fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
              });
            }

            if (fieldsAux.inputType === 'input-general-select') {
              const inputSelect = inputDataSourceAux?.inputSelect ?? { value: '', description: '' };
              const normalizedArrayData = (inputDataSourceAux?.arrayData ?? []).map((item: any) => {
                const key = inputSelect?.value;
                return key ? { ...item, [key]: String(item[key]) } : item;
              });
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                inputSelect: inputSelect,
                arrayData: inputDataSourceAux ? normalizedArrayData : [],
                urlCatalog: inputDataSourceAux ? inputDataSourceAux.urlCatalog : '',
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                functionEvent: this.generalService.stringToJson(fieldsAux.functionName),
              });
            }

            if (fieldsAux.inputType === 'input-general-autocomplete') {
              const inputSelect = inputDataSourceAux?.inputSelect ?? { value: '', description: '' };
              const normalizedArrayData = (inputDataSourceAux?.arrayData ?? []).map((item: any) => {
                const key = inputSelect?.value;
                return key ? { ...item, [key]: String(item[key]) } : item;
              });
              const body: InputGeneralAutocomplete = {
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                inputSelect: inputSelect,
                urlCatalog: inputDataSourceAux ? inputDataSourceAux.urlCatalog : '',
                arrayData: inputDataSourceAux ? normalizedArrayData : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
              };
              if (fieldsAux.value && body.arrayData.length) {
                const index = body.arrayData.findIndex((item) => item.Id === fieldsAux.value);
                if (index != -1) {
                  body.value = `${body.arrayData[index].data}`;
                } else {
                  body.value = '';
                }
              } else {
                body.value = '';
              }
              fields.push(body);
            }

            if (fieldsAux.inputType === 'input-upload-ligh') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                formatLight: true,
                colFull: true,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${fieldsAux.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                maxFiles: 1,
                maxFileSizeMB: 25,
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                function: fieldsAux.functionName ?? '',
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                AdditionalValuesFiles: fieldsAux.valoresExtra
                  ? fieldsAux.valoresExtra
                  : [
                      {
                        iD_DOCUMENTOS_COTIZACION: 0,
                        iD_CARATULA: 0,
                        systemFileName: null,
                        fileName: null,
                        legacyFileName: null,
                      },
                    ],
              });
            }

            if (fieldsAux.inputType === 'reader-PDF') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                colFull: true,
                value: '',
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${fieldsAux.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: {},
                rules: [],
                quotationId: quotationId,
                url: '',
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                functionEvent: this.generalService.stringToJson(fieldsAux.functionName),
              });
            }

            if (fieldsAux.inputType === 'button-general') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                value: fieldsAux.value,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                disabled: fieldsAux.disabled,
                error: errorAux ? errorAux : {},
                rules: rulesAux ? rulesAux.rules : [],
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: fieldsAux.colFull,
                order: fieldsAux.controlDisplayOrder ? fieldsAux.controlDisplayOrder : 0,
                function: fieldsAux.functionName ?? '',
                text: '',
              });
            }

            if (fieldsAux.inputType === 'break-line') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                error: {},
                rules: rulesAux ? rulesAux.rules : [],
                disabled: false,
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: true,
              });
            }

            if (fieldsAux.inputType === 'text-line') {
              fields.push({
                label: fieldsAux.label,
                roleType: fieldsAux.roleType,
                fieldName: fieldsAux.fieldName,
                idControl: fieldsAux.idControl,
                idFullControl: `${sectionAux.idSection}-${form.idForm}-${repeatGroups.repeatIndex}-${fieldsAux.idControl}`,
                error: {},
                function: fieldsAux.functionName,
                rules: rulesAux ? rulesAux.rules : [],
                disabled: false,
                view: fieldsAux.view,
                typeInput: fieldsAux.inputType,
                colFull: true,
              });
            }
          });

          if (Object.keys(formAux.orderDefault).length) {
            fields.forEach((input, inputIndex) => {
              input.order = formAux.orderDefault[input.idControl]
                ? formAux.orderDefault[input.idControl].order
                : 999 + inputIndex;
            });
          }

          if (Object.keys(formAux.orderRule).length) {
            Object.keys(formAux.orderRule).forEach((rule) => {
              fields.forEach((field) => {
                if (
                  formAux.orderRule[rule].inputKey.parentFieldId == `${field.idControl}` &&
                  formAux.orderRule[rule].inputKey.parentFieldValue === field.value
                ) {
                  fields.forEach((inputAux, inputIndexAux) => {
                    inputAux.order = formAux.orderRule[rule].orderInputs[inputAux.idControl]
                      ? formAux.orderRule[rule].orderInputs[inputAux.idControl].order
                      : 999 + inputIndexAux;
                  });
                }
              });
            });
          }

          fields.sort((a, b) => {
            const orderA = a.order ?? Number.MAX_SAFE_INTEGER;
            const orderB = b.order ?? Number.MAX_SAFE_INTEGER;
            return orderA - orderB;
          });

          multifrom.push({
            repeatIndex: repeatGroups.repeatIndex,
            fields: fields,
          });
        });

        if (form.idForm == 1) {
          multifrom[0].fields.forEach((input) => {
            if (input.idControl == 2 && `${input.value}` == '3') {
              multifrom[0].fields.forEach((fieldsAux) => {
                if (fieldsAux.idControl == 454) {
                  fieldsAux.label = 'Razón Social';
                  fieldsAux.colFull = true;
                  fieldsAux.disabled = false;
                }
                multifrom[0].fields.forEach((fieldsAux) => {
                  if (fieldsAux.idControl == 49) {
                    fieldsAux.label = 'Razón Social Factura';
                    fieldsAux.colFull = true;
                    fieldsAux.disabled = false;
                  }
                });
              });
            }
          });
        }
        const formGroups: GeneralForm = {
          title: form.title,
          isRepeatable: form.isRepeatable,
          description: form.subtitle,
          idForm: form.idForm,
          type: 'generalForm',
          colummNum: 4,
          multifrom: multifrom,
          orderByRule: formAux,
          hide: false,
        };

        if (form.idForm == 37 || form.idForm == 47) {
          formGroups.hide = true;
        }

        forms.push({
          collectionFormsControls: {},
          form: true,
          save: false,
          isExpasion: true,
          generateForm: {
            formGroups: formGroups,
          },
        });
      });

      Data.section.push({
        idSection: sectionAux.idSection,
        order: sectionAux.displayOrder,
        title: sectionAux.title,
        border: sectionAux.border,
        forms: forms,
        view: true,
      });
    });
    return Data;
  }

  public saveFrom(
    changedFields: {
      idCotizacion: number;
      controlId: number;
      newValue: string;
      roleType: string;
      repeatIndex: number;
    }[],
  ): Observable<any> {
    return this.http.patch<any>(this.URL_API + '/dynamic-fields', changedFields).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public saveInput(changedFields: {
    idCotizacion: number;
    controlId: number;
    newValue: string;
    roleType: string;
    repeatIndex: number;
  }): Observable<any> {
    return this.http.patch<any>(this.URL_API + '/dynamic-field', changedFields).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public transformInput(body: CustomInputConfig): Observable<any> {
    return this.http.post<any>(this.URL_API + '/manageFieldType', body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public createControl(body: CreateInpur): Observable<any> {
    return this.http.post<any>(this.URL_API + '/createControl', body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public asignControlToForm(body: {
    formId: number;
    controlId: number;
    assign: boolean;
  }): Observable<any> {
    return this.http.post<any>(this.URL_API + '/AsignControlToForm', body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // 1 crear, 2 Actualizar, 3 Eliminar
  public assignSectionToPage(
    operation: number,
    pageId: number,
    sectionId: number,
  ): Observable<any> {
    const body = { operation: operation, pageId: pageId, sectionId: sectionId };
    const params = this.generalService.buildParams(body);
    return this.http.patch<any>(this.URL_API + '/assignSectionToPage', {}, { params: params }).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // 1 crear, 2 Actualizar, 3 Eliminar
  public assignFormToSection(
    operation: number,
    formId: number,
    sectionId: number,
  ): Observable<any> {
    const params = this.generalService.buildParams({
      operation: operation,
      formId: formId,
      sectionId: sectionId,
    });
    return this.http.patch<any>(this.URL_API + '/assignFormToSection', {}, { params: params }).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public getDynamicFields(): Observable<FieldDinamic[] | null> {
    return this.http.get<FieldDinamic[]>(this.URL_API + '/getDynamicFields', {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public getSections(): Observable<Section[] | null> {
    return this.http.get<Section[]>(this.URL_API + '/getSections', {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public getForms(): Observable<SectionForm[] | null> {
    return this.http.get<SectionForm[]>(this.URL_API + '/getForms', {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public getPages(): Observable<PageGeneral[] | null> {
    return this.http.get<PageGeneral[]>(this.URL_API + '/GetPages', {}).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // 1 crear, 2 leer, 3 Actualizar
  public manageSection(body: {
    operation: number;
    sectionId: number;
    sectionName: string;
    displayOrder: number;
    isActive: number;
    border: boolean;
    view: boolean;
  }): Observable<Section[] | null> {
    return this.http.post<Section[]>(this.URL_API + '/manageSection', body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // 1 crear, 2 Lectura, 3 Actualizar Propiedades, 4 Actualizar Dymanico
  public manageForm(body: {
    action: number;
    forM_ID: number;
    title: string;
    subtitle: string;
    iS_REPEATABLE: boolean;
    hide: boolean;
    iS_ACTIVE: boolean;
    rulE_BY_ORDER: string;
  }): Observable<any | null> {
    return this.http.patch<any>(this.URL_API + '/manageFormSection', body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // 1 crear, 2 Get, 3 Actualizar
  public managePage(body: {
    operation: number;
    pageId: number;
    pageTitle: string;
    pageSubtitle: string;
    rules: string;
  }): Observable<any | null> {
    return this.http.patch<any>(this.URL_API + '/managePage', body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public assignPageToQuoteStatus(body: {
    statusId: number;
    pageId: number;
    assign: boolean;
  }): Observable<any | null> {
    return this.http.post<any>(this.URL_API + '/assignPageToQuoteStatus', body).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public uploadDocument(formData: FormData): Observable<any | null> {
    return this.http.post<any>(this.URL_API + '/api/Document/UploadDocument', formData).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  public uploadAssetDocument(formData: FormData): Observable<any | null> {
    return this.http.post<any>(this.URL_API + '/api/Document/UploadAssetDocument', formData).pipe(
      take(1),
      catchError(() => {
        return of(null);
      }),
    );
  }

  // Servicio
  public getFile(key: string): Observable<Blob | null> {
    const params = this.generalService.buildParams({ systemFileId: key });
    return this.http
      .get(this.URL_API + '/api/Document/GetFile', { params, responseType: 'blob' })
      .pipe(
        take(1),
        catchError(() => {
          this.generalService.viewSnacAlert('Error al descargar el archivo', 'error', ' Error ');
          return of(null);
        }),
      );
  }

  public viewFileLight(file: any, name?: string): void {
    this.dialog.open(ModalViewFileComponent, {
      width: '80vw',
      maxWidth: '80vw',
      maxHeight: '95vh',
      height: '95vh',
      disableClose: false,
      autoFocus: false,
      data: {
        Titule: 'Archivo ' + name,
        file: file,
      },
    });
  }
}
